import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

export const getApiPortalCode = async () => {
    try {
        const { data } = await axios.get(`${REACT_APP_API}/apiKey/generate`)
        return data?.apiKey
    } catch (error) {
        console.log(`Error getApiPortalCode `, error)
        throw error
    }
}
